export const DAIMLER_XENTRY_SYNC = 'DAIMLER_XENTRY_SYNC';
